<app-performance>
    <app-data-grid-comp
    [tableId]="db_tables.EmployeeGoals"
    [columns]="columns"
    [filterCategories]="filterCategories"
    [gridId]="gridId"
    [gridData]="gridData"
    [gridDataResult]="gridDataResult"
    [isLoading]="isLoading"
    [pageSize]="pageSize"
    [skip]="skip"
    category="AllGoals"
    [rowSelectionSettings]="{
        canSelectRows: true,
        selectableMode: 'multiple',
        selectRowBy: 'id'
    }"
    clickableRows="true"
    searchable="true"
    hideActionButtons="true"
    [sortable]="{
        mode: 'multiple'
    }"
    [sortableColumns]="sortableColumns"
    [isLoading]="isLoading"
    [clearSelectedItems]="clearSelectedItems"
    export="customExcel"
    (emitExportEvent)="allData()"
    (emitDeleteEvent)="deleteGoals($event)"
    (emitGridStateChangeEvent)="gridStateChange($event)"
    ></app-data-grid-comp>

    <kendo-excelexport
        [data]="excelData"
        [fileName]="fileName"
        #excelexport
    >
        <kendo-excelexport-column
            *ngFor="let column of excelColumns"
            [field]="column.field"
            [title]="column.title"
        >
        </kendo-excelexport-column>
    </kendo-excelexport>
</app-performance>
